import { CellContext, createColumnHelper } from "@tanstack/react-table";
import React, { useRef, useState } from "react";
import Loading from "../../cross/Loading";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import { ITipo_Campo } from "../../helpers/IFormHelper";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import { API_ADMIN_LIO_PREVENCIONISTA, ROW_COUNT, URL_SUPPORT } from "../../helpers/variableHelper";
import { shortDate } from "../../helpers/dateHelper";
import { AdminListaPagination, IPagination } from "../../controls/AdminListaPagination";
import { E_TipoBusquedaLIO } from "../../enums/E_TipoBusquedaLIO";
import LIOService from "../../services/LIOService";
import IInspeccionObservacion, { ICalculoLIO, ICausasAsignadasYCompletadas } from "../../entities/IInspeccionObservacion";
import IInspeccionAspectoEvaluar from "../../entities/IInspeccionAspectoEvaluar";
import { getAPI } from "../../helpers/httpHelper";
import RenderTitle from "../../controls/RenderTitle";
import RenderValue from "../../controls/RenderValue";

interface IHomeLIO {
  loading?: boolean;
  items?: Array<IInspeccionObservacion>;
  causas?: ICausasAsignadasYCompletadas;
  seleccionada?: number;
  itemsCausas?: Array<IInspeccionAspectoEvaluar>;
}

export default function HomeLIO({ loading = true, items = [], seleccionada, itemsCausas = [] }: IHomeLIO) {// NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 32 como valor de complejidad cognitiva. Esta función realiza varias validaciones para la carga de las acciones, y para manejar las pruebas unitarias".
  const userInfoToken = cognitoUserToken();
  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(loading);
  const [calculoLIO, setCalculoLIO] = useState<ICalculoLIO | null>(null);
  const [boxSeleccionada, setBoxSeleccionada] = useState<E_TipoBusquedaLIO>(seleccionada || E_TipoBusquedaLIO.Ninguna);
  const [listLIO, setListLIO] = useState<Array<IInspeccionObservacion>>(items || []);
  const totalPageListLIO = useRef<number>(0);
  const totalPageListCausasS = useRef<number>(0);
  const [listCausasLIO, setListCausasLIO] = useState<Array<IInspeccionAspectoEvaluar>>(itemsCausas || []);
  const [isExternoInspector, setIsExternoInspector] = useState(false);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />
  };

  const renderBoxTitle = () => {
    if (boxSeleccionada == E_TipoBusquedaLIO.Generadas) {
      return "Generadas"
    } else if (boxSeleccionada == E_TipoBusquedaLIO.Asignadas) {
      return "Asignadas"
    } else {
      return "Completadas"
    }
  }

  const componentAcciones = (info: any) => {
    return <div>
      <i
        data-testid="test1"
        className="bi bi-search iconSearch colorAzul pointer"
        title="Ver LIO"
        onClick={() => {
          window.location.href = `/agregarLIO?id=${info.row.original.ID}`;
        }}></i>
    </div>;
  };

  const componentAcciones2 = (info: any) => {
    return <div>
      <i
        data-testid="test2"
        className="bi bi-search iconSearch colorAzul pointer"
        title="Ver Desviación"
        onClick={() => {
          window.location.href = `/agregarLIO?id=${info.row.original.ID_INSPECCION_OBSERVACION}&idAspecto=${info.row.original.ID}`;
        }}></i>
    </div>
  };



  usePromiseEffect(async () => {
    let token = await userInfoToken;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    try {
      let resultCalculoHome = await LIOService.getEstadisticasHome(token, currUser);
      setCalculoLIO(resultCalculoHome);
      if (currUser.external && currUser?.roles.IS_EXT_LIO) {
        let params = {
          PAGINA: 1,
          PAGINADO: ROW_COUNT,
          ORDENADOPOR: "ID",
          ORIENTACION: "DESC",
          TITULO: null,
          NOMBRE_INSPECTOR_CONTRATISTA: currUser.email,
          ID_GERENCIA_SUBGERENCIA: null,
          ACTIVO: null,
        };
        let result = (
          await getAPI(`${URL_SUPPORT}${API_ADMIN_LIO_PREVENCIONISTA}/GetAllEmpresaInspectora`, { Authorization: `Bearer ${token}` }, params)
        ).result.data;
        setIsExternoInspector(result.length > 0);
      }
    } catch (error) { }
    setIsLoading(false);
  }, []);

  const columnHelperLIOGeneradas = createColumnHelper<IInspeccionObservacion>();
  let columnsDefLIO = [
    columnHelperLIOGeneradas.accessor((row) => row.CORRELATIVO, {
      id: "CORRELATIVO",
      cell: (
        info: CellContext<IInspeccionObservacion, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("Código"),
      tipo: ITipo_Campo.text,
      sortId: `LIO."CORRELATIVO"`,
    } as any),

    columnHelperLIOGeneradas.accessor((row) => row.TIPO_LISTA, {
      id: "TIPO_LISTA",
      cell: (
        info: CellContext<IInspeccionObservacion, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("Tipo Lista"),
      tipo: ITipo_Campo.text,
      sortId: `TL."TITULO"`,
    } as any),

    columnHelperLIOGeneradas.accessor((row) => row.FECHA_DETECCION, {
      id: "FECHA_DETECCION",
      cell: (
        info: CellContext<IInspeccionObservacion, Date>
      ) => (
        componentValue(shortDate(info.getValue()))
      ),
      header: () => component("Fecha Detección"),
      tipo: ITipo_Campo.date,
      sortId: `LIO."FECHA_DETECCION"`,
    } as any),

    columnHelperLIOGeneradas.accessor((row) => row.VICEPRESIDENCIA, {
      id: "VICEPRESIDENCIA",
      cell: (
        info: CellContext<IInspeccionObservacion, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("Vicepresidencia"),
      tipo: ITipo_Campo.text,
      sortId: `VPP."TITULO"`,
    } as any),

    columnHelperLIOGeneradas.accessor((row) => row.CONTRATISTA_SUBCONTRATISTA, {
      id: "CONTRATISTA_SUBCONTRATISTA",
      cell: (
        info: CellContext<IInspeccionObservacion, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("Contratista/Subcontratista"),
      tipo: ITipo_Campo.text,
      sortId: `CSC."TITULO"`,
    } as any),

    columnHelperLIOGeneradas.accessor((row) => row.ESTADO, {
      id: "ESTADO",
      cell: (
        info: CellContext<IInspeccionObservacion, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("Estado"),
      tipo: ITipo_Campo.text,
      sortId: `EIO."TITULO"`,
    } as any),

    columnHelperLIOGeneradas.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (
        info: CellContext<IInspeccionObservacion, string>
      ) => (
        componentAcciones(info)
      ),
      header: () => component("Acciones"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
  ] as any;

  const columnHelperLIOAsignadas = createColumnHelper<IInspeccionAspectoEvaluar>();
  let columnsDefLIOAsignadas = [
    columnHelperLIOAsignadas.accessor((row) => row.CODIGO, {
      id: "CODIGO",
      cell: (
        info: CellContext<IInspeccionAspectoEvaluar, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("Código"),
      tipo: ITipo_Campo.text,
      sortId: `LIO."CORRELATIVO"`,
    } as any),

    columnHelperLIOAsignadas.accessor((row) => row.NUMERO_ASPECTO, {
      id: "NUMERO_ASPECTO",
      cell: (
        info: CellContext<IInspeccionAspectoEvaluar, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("N Aspecto<"),
      tipo: ITipo_Campo.text,
      sortId: `ASP."TITULO"`,
    } as any),

    columnHelperLIOAsignadas.accessor((row) => row.ASPECTO, {
      id: "ASPECTO",
      cell: (
        info: CellContext<IInspeccionAspectoEvaluar, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("Aspecto"),
      tipo: ITipo_Campo.text,
      sortId: `ASP."TITULO"`,
    } as any),

    columnHelperLIOAsignadas.accessor((row) => row.ACCION, {
      id: "ACCION",
      cell: (
        info: CellContext<IInspeccionAspectoEvaluar, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("Acción"),
      tipo: ITipo_Campo.text,
      sortId: `LAE."ACCION_REALIZADA"`,
    } as any),

    columnHelperLIOAsignadas.accessor((row) => row.ESTADO, {
      id: "ESTADO",
      cell: (
        info: CellContext<IInspeccionAspectoEvaluar, string>
      ) => (
        componentValue(info.getValue())
      ),
      header: () => component("Estado"),
      tipo: ITipo_Campo.text,
      sortId: `EAE."TITULO"`,
    } as any),

    columnHelperLIOGeneradas.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (//   
        info: CellContext<IInspeccionAspectoEvaluar, string>
      ) => (
        componentAcciones2(info)
      ),
      header: () => component("Acciones"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
  ] as any;

  const handleReloadLIOHome = async (tipoBusqueda: E_TipoBusquedaLIO, pagination?: IPagination) => {
    const defaultPagination: IPagination = pagination || {
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
    };
    let result = await LIOService.getListadoLIOHome(token, {
      ...defaultPagination,
      TIPO_BUSQUEDA: tipoBusqueda,
      USUARIO: currentUser?.email as string
    });
    let arrLIOGeneradas = result.data !== undefined ? result.data : items;
    totalPageListLIO.current = result.pages;
    setListLIO(arrLIOGeneradas);
    setBoxSeleccionada(tipoBusqueda);
  };

  const handleReloadCausas = async (tipo: E_TipoBusquedaLIO, pagination?: IPagination) => {
    const defaultPagination: IPagination = pagination || {
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
    };
    let result = await LIOService.getListadoAsignadasHome(token, {
      ...defaultPagination,
      TIPO_BUSQUEDA: tipo,
      USUARIO: currentUser?.email as string
    });
    let arrLIOAsignadas = result.resultCode !== 500 ? result.data : itemsCausas;
    totalPageListCausasS.current = result.pages;
    setListCausasLIO(arrLIOAsignadas);
    setBoxSeleccionada(tipo);
  };

  return isLoading ? (
    <Loading />
  ) : (
    <div className="row">
      <div className="col-12">
        <div className="rounded bg-white p-2 shadow">
          <div className="container mb-4">
            <div className="card bgGris p-3 border-0">
              <h3 className="titSecundario colorTit">Lista Inspección/Observación</h3>
              <div className="row">
                <div className="row">
                  {(isExternoInspector || !currentUser?.external) && (
                    <>
                      <div className="col-sm-12 col-md-6 col-lg-3">
                        <div
                          data-testid="Generadas"
                          className={`card p-3 modulo shadow ${boxSeleccionada == E_TipoBusquedaLIO.Generadas && "moduloActive"}`}
                          onClick={async () => {
                            handleReloadLIOHome(E_TipoBusquedaLIO.Generadas);
                          }}>
                          <div className="row">
                            <div className="col-8 d-flex align-items-center">
                              <i className="bi bi-file-text colorVerde"></i>
                              <span>Generadas</span>
                            </div>
                            <div className="col-4">
                              <span className="caja text-white gradienteVerde">
                                <span>{calculoLIO?.LIO_GENERADAS}</span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-12 col-md-6 col-lg-3">
                        <div
                          data-testid="Asignadas"
                          className={`card p-3 modulo shadow ${boxSeleccionada == E_TipoBusquedaLIO.Asignadas && "moduloActive"}`}
                          onClick={async () => {
                            handleReloadLIOHome(E_TipoBusquedaLIO.Asignadas);
                          }}>
                          <div className="row">
                            <div className="col-8 d-flex align-items-center">
                              <i className="bi bi-file-text colorVerde"></i>
                              <span>Asignadas</span>
                            </div>
                            <div className="col-4">
                              <span className="caja text-white gradienteVerde">
                                <span>{calculoLIO?.LIO_ASIGNADAS}</span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-12 col-md-6 col-lg-3">
                        <div
                          data-testid="Completadas"
                          className={`card p-3 modulo shadow ${boxSeleccionada == E_TipoBusquedaLIO.Completadas && "moduloActive"}`}
                          onClick={async () => {
                            handleReloadLIOHome(E_TipoBusquedaLIO.Completadas);
                          }}>
                          <div className="row">
                            <div className="col-8 d-flex align-items-center">
                              <i className="bi bi-file-text colorVerde"></i>
                              <span>Completadas</span>
                            </div>
                            <div className="col-4">
                              <span className="caja text-white gradienteVerde">
                                <span>{calculoLIO?.LIO_COMPLETADAS}</span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-3">
                        <div
                          data-testid="Agregar"
                          className="card p-3 modulo shadow"
                          onClick={() => {
                            window.location.href = "/agregarLIO";
                          }}>
                          <div className="row ">
                            <div className="col-12 text-center colorAzul ">
                              Agregar <i className="bi bi-plus-circle-fill"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className="row">
                  <div className="col-12 mt-3 mb-1">
                    <h3 className="titSecundario colorTit">Acciones Asignadas</h3>
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div
                      data-testid="Acciones Asignadas"
                      className={`card p-3 modulo shadow ${boxSeleccionada == E_TipoBusquedaLIO.Aasignadas && "moduloActive"}`}
                      onClick={async () => {
                        handleReloadCausas(E_TipoBusquedaLIO.Aasignadas);
                      }}>
                      <div className="row">
                        <div className="col-8 d-flex align-items-center">
                          <i className="bi bi-file-text colorAzul"></i>
                          <span>Acciones Asignadas</span>{" "}
                        </div>
                        <div className="col-4">
                          <span className="caja text-white gradienteAzul">
                            <span>{calculoLIO?.ACCIONES_ASIGNADAS}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div
                      data-testid="Completadas Asignadas"
                      className={`card p-3 modulo shadow ${boxSeleccionada == E_TipoBusquedaLIO.Acompletadas && "moduloActive"}`}
                      onClick={async () => {
                        handleReloadCausas(E_TipoBusquedaLIO.Acompletadas);
                      }}>
                      <div className="row">
                        <div className="col-8 d-flex align-items-center">
                          <i className="bi bi-file-text colorAzul"></i>
                          <span>Completadas Asignadas</span>{" "}
                        </div>
                        <div className="col-4">
                          <span className="caja text-white gradienteAzul">
                            <span>{calculoLIO?.ACCIONES_COMPLETADAS}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {(boxSeleccionada == E_TipoBusquedaLIO.Generadas ||
            boxSeleccionada == E_TipoBusquedaLIO.Asignadas ||
            boxSeleccionada == E_TipoBusquedaLIO.Completadas) && (
              <div className="row" id="tlbGeneradas">
                <div className="col-12">
                  <div className="container-fluid mb-4">
                    <h1 className="titPrincipal colorTit mt-2">
                      {renderBoxTitle()}
                    </h1>
                    <div className="row">
                      <div className="col-12">
                        <AdminListaPagination
                          defaultSortBy="CORRELATIVO"
                          sortDirection="DESC"
                          totalPages={totalPageListLIO}
                          resultPerPage={ROW_COUNT}
                          callback={(pagination) => {
                            handleReloadLIOHome(boxSeleccionada, pagination);
                          }}
                          data={listLIO}
                          reload={() => {
                            handleReloadLIOHome(boxSeleccionada);
                          }}
                          columnsDef={columnsDefLIO}
                          hideAdd={true}
                          hideExport={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          {(boxSeleccionada == E_TipoBusquedaLIO.Aasignadas || boxSeleccionada == E_TipoBusquedaLIO.Acompletadas) && (
            <div id="seccionAccionesAsignadas">
              <h1 className="titPrincipal colorTit mt-2">
                {boxSeleccionada == E_TipoBusquedaLIO.Aasignadas ? "Acciones Asignadas" : "Completadas Asignadas"}
              </h1>
              <AdminListaPagination
                defaultSortBy="CORRELATIVO"
                sortDirection="DESC"
                totalPages={totalPageListCausasS}
                resultPerPage={ROW_COUNT}
                callback={(pagination) => {
                  handleReloadCausas(boxSeleccionada, pagination);
                }}
                data={listCausasLIO}
                reload={() => {
                  handleReloadCausas(boxSeleccionada);
                }}
                columnsDef={columnsDefLIOAsignadas}
                hideAdd={true}
                hideExport={true}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
